import { render, staticRenderFns } from "./DadosASeremAtualizados.vue?vue&type=template&id=56d95803"
import script from "./DadosASeremAtualizados.vue?vue&type=script&lang=js"
export * from "./DadosASeremAtualizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports